import { lightTheme } from '../ui/theme/theme';

const BASE_API_ENDPOINT = 'https://minigolf-backend.fly.dev/api/weddie-site/';
const API_ENDPOINT = BASE_API_ENDPOINT + 'send-email';
const TOKEN_ENDPOINT = BASE_API_ENDPOINT + 'token';

const AUTH_TOKEN = 'a3ZCanNsVHJ3cThEejlKc3c2RFhVM3M1YjQxcURyWTE2UVUyaDBQT3d3enFQQzhaY2JhWHBZejVWclJidUdhb2EwUVFaZkQ4Qnh4b0dERVlGY1ZrUlhRaEtFb25QUWJReTJHSDBJOElWbDJHMWxTaDU2TE9QYjl5NTZ2SnA4dGI';

interface EmailRequestData {
    sentTo: string;
    sentFrom: string;
    topic: string;
    message: string;
    html: string;
}

interface TokenResponse {
    token: string;
}

export const getSupertoken = async (): Promise<TokenResponse> => {
    try {
        const response = await fetch(TOKEN_ENDPOINT, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AUTH_TOKEN}`,
            },
        });
        
        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        const data: TokenResponse = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting supertoken:', error);
        throw error;
    }
};

export const sendEmail = async (emailData: EmailRequestData): Promise<Response> => {
    try {
        const response = await fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AUTH_TOKEN}`,
            },
            body: JSON.stringify(emailData),
        });
        
        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        return response;
    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
};

export const createEmailHtml = (contact: string, message: string): string => {
    const html = `
        <!DOCTYPE html>
        <html>
        <head>
            <style>
                body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
                .container { max-width: 600px; margin: 0 auto; padding: 20px; }
                .header { background-color: ${lightTheme.palette.primary.main}; color: white; padding: 10px 20px; border-radius: 5px 5px 0 0; }
                .content { background-color: #f9f9f9; padding: 20px; border-radius: 0 0 5px 5px; }
                .field { margin-bottom: 20px; }
                .label { font-weight: bold; margin-bottom: 5px; }
                .value { padding: 10px; background-color: white; border-radius: 3px; border: 1px solid #ddd; }
                .footer { margin-top: 20px; font-size: 12px; color: #777; }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <h2>New Contact Form Submission</h2>
                </div>
                <div class="content">
                    <div class="field">
                        <div class="label">Contact:</div>
                        <div class="value">${contact}</div>
                    </div>
                    <div class="field">
                        <div class="label">Message:</div>
                        <div class="value">${message.replace(/\n/g, '<br>')}</div>
                    </div>
                </div>
                <div class="footer">
                    <p>This email was sent from the Weddie Site contact form.</p>
                </div>
            </div>
        </body>
        </html>
    `;
    return html.replace(/\n/g, '');
};

interface RsvpEmailData {
    who: string;
    email: string;
    message: string;
    coupleName1: string;
    coupleName2: string;
}

export const createRsvpEmailHtml = ({ who, email, message, coupleName1, coupleName2 }: RsvpEmailData): string => {
    const { palette } = lightTheme;
    const PRIMARY = palette.primary.main;
    const PRIMARY_LIGHT = palette.primary.light;
    const PRIMARY_DARK = palette.primary.dark;
    const SECONDARY = palette.secondary.main;
    const SECONDARY_LIGHT = palette.secondary.light;

    const coupleLabel = `${coupleName1} & ${coupleName2}`;

    const html = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
        </head>
        <body style="margin:0;padding:0;background-color:${SECONDARY_LIGHT};font-family:'Georgia','Times New Roman',serif;">
            <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background-color:${SECONDARY_LIGHT};padding:40px 20px;">
                <tr><td align="center">
                    <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width:600px;width:100%;">
                        <tr><td style="text-align:center;padding:30px 0 10px 0;">
                            <span style="font-size:42px;">💌</span>
                        </td></tr>
                        <tr><td style="text-align:center;padding-bottom:30px;">
                            <h1 style="margin:0;font-size:32px;color:${PRIMARY_DARK};font-family:'Georgia','Times New Roman',serif;font-weight:400;letter-spacing:2px;">New RSVP Response</h1>
                            <div style="width:60px;height:3px;background:linear-gradient(to right,${PRIMARY_LIGHT},${PRIMARY},${PRIMARY_LIGHT});margin:15px auto 0 auto;border-radius:2px;"></div>
                        </td></tr>

                        <tr><td style="background-color:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 4px 20px rgba(218,170,152,0.2);">
                            <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                <tr><td style="background:linear-gradient(135deg,${PRIMARY},${PRIMARY_DARK});padding:24px 32px;">
                                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                        <tr>
                                            <td style="color:#ffffff;font-size:14px;text-transform:uppercase;letter-spacing:3px;opacity:0.85;">From</td>
                                        </tr>
                                        <tr>
                                            <td style="color:#ffffff;font-size:26px;font-family:'Georgia','Times New Roman',serif;padding-top:6px;font-weight:400;">${who}</td>
                                        </tr>
                                    </table>
                                </td></tr>

                                <tr><td style="padding:28px 32px;">
                                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
                                        <tr><td style="padding-bottom:22px;">
                                            <div style="font-size:11px;text-transform:uppercase;letter-spacing:2px;color:${PRIMARY_DARK};font-weight:700;margin-bottom:8px;">✉ Contact Email</div>
                                            <div style="font-size:17px;color:#333;padding:14px 18px;background-color:${SECONDARY};border-radius:10px;border-left:4px solid ${PRIMARY};">${email}</div>
                                        </td></tr>

                                        <tr><td>
                                            <div style="font-size:11px;text-transform:uppercase;letter-spacing:2px;color:${PRIMARY_DARK};font-weight:700;margin-bottom:8px;">💬 Message</div>
                                            <div style="font-size:17px;color:#333;padding:18px;background-color:${SECONDARY};border-radius:10px;border-left:4px solid ${PRIMARY_LIGHT};line-height:1.7;">${message.replace(/\n/g, '<br>')}</div>
                                        </td></tr>
                                    </table>
                                </td></tr>
                            </table>
                        </td></tr>

                        <tr><td style="text-align:center;padding:28px 0 10px 0;">
                            <div style="display:inline-block;background-color:${SECONDARY};border-radius:30px;padding:12px 28px;">
                                <span style="font-size:14px;color:${PRIMARY_DARK};font-family:'Georgia','Times New Roman',serif;">${coupleLabel} — weddie.site 💕</span>
                            </div>
                        </td></tr>
                    </table>
                </td></tr>
            </table>
        </body>
        </html>
    `;
    return html.replace(/\n/g, '');
};

export const validateEmail = (email: string): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const validatePhone = (phone: string): boolean => {
    const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/;
    return re.test(String(phone));
};
